import { ApiRequestInterceptor } from "./apiRequest";
import { REPARTIDORES } from "../Constants/Endpoints"; // o Endpoints, cuida el nombre

export const fetchCourierAssignOrder = async (orderId) => {
    const method = "POST";
    const url = `${REPARTIDORES.assignOrder}`; // "courier/orders/assign"
    const body = { orderId };
    const response = await ApiRequestInterceptor(url, method, body);

    const parsed = typeof response?.body === "string" ? JSON.parse(response.body) : response?.body;
    return {
        statusCode: response.statusCode || 200,
        ...response,
        body: parsed ?? response.body,
    };
};